import React, { ReactElement } from 'react';
import styles from './EditModalColumn.module.css';

export interface TemplateModalColumnProps {
  data: TemplateModalDataItem[];
}

export function TemplateModalColumn({
  data,
}: TemplateModalColumnProps): ReactElement {
  return (
    <div className={styles.root}>
      <ul className={styles.ul}>
        {data.map((item, index) => (
          <li key={index} className={styles.li}>
            {item.label && <span className={styles.label}>{item.label}</span>}
            <span className={styles.value}>{item.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
